import React from 'react'
import {
  Container,
  Row,
  Col
} from 'reactstrap'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const Section = styled.section`
  .illustration {
    width: 100%;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    padding: 32px 0;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    padding-bottom: 50px;
    min-height: calc(100vh - 50px - 56px);
    display: flex;
    align-items: center;
  }
`

const Heading = styled.h1`
  font-size: 2rem;
  color: #4a4a4a;
  font-weight: ${fontWeight.medium};
  margin-top: 0;
  margin-bottom: 32px;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 2rem;
    margin-bottom: 16px;
  }
`

const Description = styled.p`
  font-size: 1.5rem;
  color: #4a4a4a;
  margin-bottom: 0;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1rem;
    text-align: justify;
  }
`

const HeroUnit = ({ data }) => {
  const { heading, description, illustration } = data
  return (
    <Section>
      <Container>
        <Row className='align-items-center'>
          <Col md={6}>
            <Heading className='wow fadeInDown'>{heading}</Heading>
            <Description className='wow fadeInDown'>{description}</Description>
          </Col>
          <Col md={6}>
            <img src={illustration.publicURL} className='illustration' alt='illustration' />
          </Col>
        </Row>
      </Container>
    </Section>
  )
}

HeroUnit.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
}

export default HeroUnit
